<template>
    <div class="criteria">
      <div class="left" v-html="title">
      </div>

      <div class="right">
          <div class="increase">
            {{objectif}}
          </div>
          <div class="objectifOf">
          {{number}}
            <span>/{{ofThem}}</span>
          </div>
      </div>
    </div>
</template>


<script>

export default {
name:"wrapperCriteria",
  props:{
    title:{
      type:String,
      default:'Position<br> sur ce critère'
      },
    objectif:{
      type:String,
      default:'+1'
      },
    number:{
      type:Number,
      default:1
      },
    ofThem:{
      type:Number,
      default:4
      }
  },
data(){
  return {
  }
},
mounted () {
}
}
</script>